import { Typography } from "@mui/material";
import { FC } from "react";
import { useIntl } from "react-intl";
import { Section } from "../../../Components/Section/Section";
import QuickpartsLogo from "../../../Images/quickparts_logo.svg";
import QuickpartsImage from "../../../Images/quickparts_portal.png";
import { ExampleImage, Logo, TitleRow } from "../Products.styles";
import { TextColumn } from "../TextColumn";
import { ImageColumn } from "../ImageColumn";

export const QuickpartsContainer: FC = () => {
  const intl = useIntl();
  return (
    <Section id="quickparts" backgroundImage="PurpleBlob">
      <TextColumn>
        <TitleRow>
          <Logo src={QuickpartsLogo} alt="Signature logo" />
          <Typography variant="h1" component="h2">
            Simpledoc Quick Parts
          </Typography>
        </TitleRow>
        <Typography variant="subtitle1">
          {intl.formatMessage({
            id: "products.quickparts.title.1",
          })}
        </Typography>
        <Typography fontWeight="bold">
          {intl.formatMessage({
            id: "products.quickparts.description.1",
          })}
        </Typography>
        <Typography>
          {intl.formatMessage({
            id: "products.quickparts.description.2",
          })}
        </Typography>
        <Typography>
          {intl.formatMessage({
            id: "products.quickparts.description.3",
          })}
        </Typography>
        <Typography>
          {intl.formatMessage({
            id: "products.quickparts.description.4",
          })}
        </Typography>
      </TextColumn>
      <ImageColumn>
        <ExampleImage src={QuickpartsImage} direction="horizontal" />
      </ImageColumn>
    </Section>
  );
};
